<template>
    <v-container class="fill-height d-flex justify-center">
        <v-sheet id="sheet1" class="fill-screen mt-16">
            <div id="ownthis" :style="`font-size: ${$vuetify.breakpoint.mobile ? '2.5em' : '5em'} !important`" class="mt-16 message animate__animated animate__fadeIn animate__slower">Own this?</div>
            <v-img
                   class="animate__animated animate__fadeIn animate__delay-2s delay-2x animate__slow"
                   :max-width="$vuetify.breakpoint.mobile ? 320 : 640"
                   :class="{ 'mt-12' : $vuetify.breakpoint.mobile }"
                   contain
                   :src="`/Black_Red_Lace_Diamante_Underwired_Padded_Bra_146110_1dcc.${extension}`"></v-img>
            <div
                 class="d-flex justify-center arrow animate__animated animate__fadeIn animate__delay-3s delay-2x animate__slow"
                 @click="$vuetify.goTo('#sheet2', gotoTransition.default)">
                🔻
            </div>
        </v-sheet>
        <v-row v-if="$vuetify.breakpoint.mobile" class="fill-screen"> </v-row>
        <v-row>
            <v-col>
                <v-sheet id="sheet2" :class="$vuetify.breakpoint.mobile ? 'allura-mobile' : 'allura'" class="fill-screen align-self-center">
                    <p :class="$vuetify.breakpoint.mobile ? '' : 'mb-16'">
                        <span v-intersect="onIntersect" class="oneline">Well, maybe not that bra exactly, but A bra just the same...</span><br />
                        Except maybe your bra is old and you're ready to toss it?<br />
                    </p>
                    <p>Turn your bra into a <span style="color: #F44336" class="font-weight-thin pr-2">BraNFT™</span> instead.<br /></p>
                    <ts-nft-example v-if="!$vuetify.breakpoint.mobile" ref="example" :eager="true" class="my-6"></ts-nft-example>
                    <v-img v-else ref="example" :src="nft.screenshots[0].url" class="my-6"></v-img>
                    <div>
                        <p>Re-purpose your old bra into something of value again,<br />
                            support other women, <sup><a target="_blank" rel="noopener" style="text-decoration: none" href="https://branfts.com/faq?id=622129ce1416900001d55656">(What?)</a></sup><br />
                            and make <span class="money">money</span> doing it!
                        </p>
                        <div
                             class="d-flex justify-center arrow animate__animated animate__fadeIn animate__delay-4s delay-2x animate__slow"
                             @click="$vuetify.goTo('#sheet3', gotoTransition.sheet3)">
                            🔻
                        </div>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
        <v-row v-if="!$vuetify.breakpoint.mobile" class="fill-screen"></v-row>
        <v-row>
            <v-col>
                <v-sheet id="sheet3" class="fill-screen d-flex align-self-center">
                    <div :class="$vuetify.breakpoint.mobile ? 'mobile' : ''" class="message animate__animated animate__fadeIn animate__slower">
                        <span style="font-size: 2em">Own this.</span><br />
                        <v-btn id="signup-button" small dark elevation="0" color="red" @click="signup"><span class="black--text font-weight-medium">Sign up</span></v-btn>
                    </div>
                    <v-dialog v-model="dialog.signup" :width="$vuetify.breakpoint.mobile ? '100%' : 640">
                        <bnft-username-card ref="bnft-username-card" :signupAttemptWithoutUsername="signupAttemptWithoutUsername"></bnft-username-card>
                    </v-dialog>
                </v-sheet>
            </v-col>
        </v-row>
        <v-row v-if="!$vuetify.breakpoint.mobile" class="fill-screen"> </v-row>
        <v-bottom-navigation shift text :value="navigation" class="elevation-0">
            <v-btn v-if="isRegistered" to="account" @mouseout="navigation = undefined" @mouseover="navigation = 'signin'" class="rounded-lg" value="signin">
                <span class="font-weight-light">Sign In</span>
                <v-icon :large="navigation != 'signin'" color="#F44336">{{ mdiLoginVariant }}</v-icon>
            </v-btn>
        </v-bottom-navigation>
        <v-snackbar :value="error">{{ errorMessage }}</v-snackbar>
    </v-container>
</template>
<style>
.oneline {
    white-space: nowrap;
}
.text--black {
    color: black;
}
.fill-screen {
    height: 100vh;
}
#ownthis {
    width: 100%;
    position: absolute;
    left: 0;
    z-index: 1;
}
p {
    text-align: center;
}
.money {
    color: green;
}
.allura {
    font-family: "Allura", cursive;
    font-size: xx-large;
}
.allura-mobile {
    font-family: "Allura", cursive;
    font-size: large;
}
.message {
    font-family: "Allura", cursive;
    font-size: xx-large;
    position: absolute;
    width: 640px;
    text-align: center;
    margin: auto;
}
#signup-button {
    font-family: Open Sans !important;
}
#sheet3 .message {
    position: inherit;
}
.arrow {
    font-size: xx-large;
    cursor: pointer;
}
#sheet3 .arrow {
    margin: unset;
}
.animate__slowest {
    --animate-duration: 7s;
}
.delay-2x {
    --animate-delay: 2s;
}
</style>
<style scoped>
</style>
<script>
import "animate.css";
import TsNftExample from "../components/TsNftExample.vue";
import BnftUsernameCard from "../components/BnftUsernameCard.vue";
import nft from "../assets/nft.js";
import { mdiLoginVariant } from "@mdi/js";
import goTo from "vuetify/lib/services/goto";
import Promise from "bluebird";

export default {
    name: "BraNFT",
    components: {
        TsNftExample,
        BnftUsernameCard,
    },
    props: {},
    data: function () {
        return {
            nft,
            gotoTransition: {
                default: {
                    duration: 2000,
                    easing: "easeInOutQuart", // how to change this to easeInOutBack from https://easings.net/ ?
                    offset: 100,
                },
                sheet3: {
                    duration: 2000,
                    easing: "easeInOutQuart", // how to change this to easeInOutBack from https://easings.net/ ?
                },
                signup: {
                    offset: this.$vuetify.breakpoint.height / 2,
                },
            },
            dialog: {
                signup: false,
            },
            setFirstLoad: { bool: true },
            userHasScrolled: false,
            mdiLoginVariant,
            navigation: undefined,
            error: false,
            errorMessage: null,
        };
    },
    methods: {
        onIntersect() {
            this.userHasScrolled = true;
        },
        signup() {
            // eslint-disable-next-line no-constant-condition
            if (false && this.$auth.isAuthenticated) {
                this.$router.push("/account");
            } else {
                this.dialog.signup = true;
                this.$nextTick(() =>
                    this.$refs["bnft-username-card"].getAvailableUsernames()
                );
            }
        },
    },
    computed: {
        extension() {
            return /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? 'jpeg' : 'webp'
        },
        signupAttemptWithoutUsername() {
            const { $route } = this;
            return (
                $route.query.error &&
                $route.query.error_description &&
                $route.query.error_description.match(
                    /username is required for signup/i
                ) ? true : false
            );
        },
        isRegistered() {
            const registrationCookie = this.$cookies.get('__secure-registered');
            return registrationCookie ? registrationCookie : false;
        }
    },
    mounted() {
        const self = this;
        if (self.signupAttemptWithoutUsername || self.$route.query.signup) {
            goTo("#signup-button", self.gotoTransition.signup)
                .then(() => Promise.delay(2000))
                .then(self.signup);
        } else if (process.env.NODE_ENV === "production") {
            setTimeout(() => {
                if (!self.userHasScrolled)
                    self.$vuetify.goTo("#sheet2", self.gotoTransition.default);
            }, 11000);
        }
    },
};
</script>
